export default __webpack_public_path__ + "static/Gaggenau-08-Regular-49ce42e5b30072c4277f9c7e0ae1590c.woff";